<template>
<svg @mouseover="isHover=true" @mouseout="isHover=false"
   version="1.1"
   id="svg1825"
   xml:space="preserve"
   :width="width"
   :height="height"
   viewBox="1 1 72 72"
   sodipodi:docname="annotated biblography-button.ai"
   inkscape:version="1.1 (ce6663b3b7, 2021-05-25)"
   xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape"
   xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs6"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath16"><path
         d="M 0,56.102 H 56.099 V 0 H 0 Z"
         id="path14" /></clipPath><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath44"><path
         d="M 1.95996,54.0659 H 54.4014 V 1.625 H 1.95996 Z"
         id="path42" /></clipPath></defs><sodipodi:namedview
     id="namedview4"
     pagecolor="#ffffff"
     bordercolor="#666666"
     borderopacity="1.0"
     inkscape:pageshadow="2"
     inkscape:pageopacity="0.0"
     inkscape:pagecheckerboard="0"
     showgrid="false"
     inkscape:zoom="11.283"
     inkscape:cx="37.401402"
     inkscape:cy="37.445716"
     inkscape:window-width="1848"
     inkscape:window-height="1016"
     inkscape:window-x="72"
     inkscape:window-y="27"
     inkscape:window-maximized="1"
     inkscape:current-layer="g8" />
    <g  v-if="isHover"
      id="g26"
      transform="matrix(1.3333333,0,0,-1.3333333,0,73.2532)" fill="#000000">
      <g
        id="g28">
        <g
          id="g30"
          clip-path="url(#clipPath34)">
          <g
            id="g36"
            transform="translate(53.4399,1.8496)">
            <path
              d="m 0,0 c 0,-0.419 -0.281,-0.759 -0.633,-0.759 h -51.174 c -0.351,0 -0.633,0.34 -0.633,0.759 v 50.926 c 0,0.42 0.282,0.757 0.633,0.757 H -0.633 C -0.281,51.683 0,51.346 0,50.926 Z"
              style="fill:none;fill-opacity:1;fill-rule:nonzero;stroke:none"
              id="path38" />
          </g>
          <g
            id="g40"
            transform="translate(53.4399,1.8496)">
            <path
              d="m 0,0 c 0,-0.419 -0.281,-0.759 -0.633,-0.759 h -51.174 c -0.351,0 -0.633,0.34 -0.633,0.759 v 50.926 c 0,0.42 0.282,0.757 0.633,0.757 H -0.633 C -0.281,51.683 0,51.346 0,50.926 Z"
              style="fill:none;stroke:#772e18;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
              id="path42" />
          </g>
          <g
            id="g44"
            transform="translate(35.8921,21.876)">
            <path
              d="M 0,0 C 0.063,0.083 2.043,3.535 2.188,3.708 3.146,4.854 5.944,5.174 6.292,5.104 7.938,4.771 8.354,5.479 8.5,5.625 8.646,5.771 10.229,6.646 10.604,6.458 10.979,6.271 11.125,5.896 11,5.354 10.875,4.813 9.917,2.937 9.542,2.771 9.167,2.604 2.521,0.292 2.188,-0.021 1.854,-0.333 0.854,-1.541 0.813,-2.375 0.796,-2.704 -0.583,-2.501 -0.958,-2.604 -1.333,-2.708 -1.938,-2.958 -2.042,-3.125 -2.146,-3.292 -2.639,-4.93 -3.875,-4.792 -4.438,-4.729 -4.079,-3.303 -3.979,-3.042 -3.646,-2.167 -0.063,-0.083 0,0"
              style="fill:#86bd9f;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path46" />
          </g>
          <g
            id="g48"
            transform="translate(1.583,35.1284)">
            <path
              d="m 0,0 c 3.903,-2.875 8.832,-4.313 14.558,-3.619 -2.687,0.911 -4.329,2.64 -6.252,4.15 2.215,0.97 3.042,-0.431 4.611,-0.567 4.502,-0.391 10.11,2.904 14.368,4.735 3.468,1.492 5.281,2.657 7.463,-0.657 3.468,0.385 7.968,4.492 11.332,1.208 0.039,-1.137 -0.635,-1.363 -1.247,-1.668 1.758,-1.522 1.629,-6.599 0.467,-8.902 -0.802,-0.163 -0.384,0.626 -0.386,1.088 -1.641,-1.492 -2.993,-1.519 -4.766,-2.794 -1.141,-0.042 -1.049,0.879 -1.955,1.021 -0.586,-0.436 -0.541,-1.681 -1.053,-2.213 -1.117,-0.102 0.19,1.694 -0.836,1.665 -4.076,-0.118 -4.888,-4.417 -5.748,-8.658 1.934,0.889 4.768,3.191 5.721,6.321 1.576,0.451 2.59,1.625 5.058,0.936 1.581,0.25 1.93,2.077 4.319,1.292 0.734,-7.372 -9.164,-3.681 -10.514,-9.372 -0.894,5.803 10.303,2.807 9.94,8.921 -1.579,0.242 -1.895,-1.133 -3.039,-1.447 -4.551,0.983 -6.209,-1.737 -7.385,-5.074 -1.953,-0.764 -3.823,-1.632 -4.412,-4.139 0.759,-0.566 2.082,0.687 2.078,2.084 0.834,-0.428 1.773,-0.777 2.435,-1.34 0.618,0.875 2.467,1.473 3.713,0.585 0.301,0.698 -0.279,0.708 -0.097,1.314 2.029,0.068 4.734,-0.727 5.57,0.875 1.183,-0.518 -0.176,-2.412 -0.156,-3.363 0.158,-0.648 0.828,0.487 1.57,0.068 -0.311,-1.284 -1.166,-1.867 -1.66,-2.917 -4.787,0.002 -8.035,-1.968 -12.291,-2.651 -7.871,-5.365 -19.939,-6.674 -31.468,-4.193"
              style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path50" />
          </g>
          <g
            id="g52"
            transform="translate(35.7544,38.7207)">
            <path
              d="m 0,0 c -1.049,0.296 -1.432,1.941 -2.598,2.14 -1.263,0.215 -5.975,-2.048 -7.904,-2.929 -4.119,-1.883 -8.002,-4.338 -13.378,-3.037 1.525,-1.435 3.425,-2.576 6.123,-3.093 -2.03,-0.963 -3.848,-2.19 -5.63,-3.47 2.593,-1.065 4.58,-2.6 7.948,-3.058 -1.927,-0.697 -3.536,-1.801 -4.155,-4.17 -3.049,-0.05 -4.071,-2.696 -6.652,-3.344 2.729,-1.148 5.556,-3.097 8.746,-2.897 0.878,0.055 1.444,1.093 2.37,0.229 -1.443,-1.02 -3.435,-1.336 -4.51,-2.827 1.627,-0.427 3.262,-0.848 4.775,-1.368 -1.001,-1.191 -2.774,-1.39 -3.711,-2.664 6.358,-0.133 11.593,1.17 15.361,4.353 2.596,-0.188 5.445,2.005 8.098,2.386 2.062,0.298 4.654,-0.722 4.894,1.737 -1.609,-1.598 -3.361,-0.007 -4.898,0.344 -2.873,0.655 -7.981,-0.327 -9.766,-1.14 1.149,3.585 0.897,9.099 2.989,11.597 2.992,3.573 13.685,2.162 13.334,9.024 -0.233,0.822 -1.45,0.874 -1.317,1.983 -0.131,1.156 0.969,0.735 0.988,1.699 C 8.09,4.524 3.451,-0.976 0,0"
              style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path54" />
          </g>
          <g
            id="g56"
            transform="translate(42.4165,29.7939)">
            <path
              d="M 0,0 C 0.225,-0.072 0.291,-0.267 0.359,-0.462 1.223,-0.378 1.402,0.575 2.176,0.773 1.604,1.865 0.744,0.167 0,0"
              style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path58" />
          </g>
          <g
            id="g60"
            transform="translate(41.0845,29.124)">
            <path
              d="M 0,0 C 0.338,-0.044 0.045,-0.583 0.336,-0.664 0.521,-0.192 1.27,-0.439 1.102,0.488 0.615,0.48 0.191,0.388 0,0"
              style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path62" />
          </g>
          <g
            id="g64"
            transform="translate(35.3364,17.0176)">
            <path
              d="m 0,0 c -0.342,0.044 -0.684,0.086 -1.025,0.126 -0.106,-0.734 -0.039,-1.689 -0.639,-1.795 0.738,-0.234 1.518,-0.545 2.256,-0.276 0.17,0.524 0.89,2.511 0.482,2.23 C 0.869,-0.243 0.625,-0.72 0.283,-1.074 0.002,-0.862 -0.094,-0.504 0,0"
              style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path66" />
          </g>
          <g
            id="g68"
            transform="translate(33.6958,17.2197)">
            <path
              d="m 0,0 c -0.547,-0.25 -0.961,-0.668 -1.201,-1.31 0.482,0.007 0.783,-0.128 1,-0.331 C -0.109,-1.262 0.494,-0.346 0,0"
              style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path70" />
          </g>
          <g
            id="g72"
            transform="translate(30.1626,15.5723)">
            <path
              d="M 0,0 C 0.371,0.316 0.977,0.331 1.689,0.209 1.922,1.518 -0.615,0.581 0,0"
              style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path74" />
          </g>
          <g
            id="g76"
            transform="translate(34.2896,18.3525)">
            <path
              d="M 0,0 C -0.031,-0.355 -0.191,-0.548 -0.35,-0.736 0.365,-0.664 1.643,-1.312 1.988,-0.764 1.416,-0.439 0.785,-0.16 0,0"
              style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path78" />
          </g>
          <g
            id="g80"
            transform="translate(13.2104,7.6807)">
            <path
              d="M 0,0 C -0.065,0.799 0.598,2.166 0.059,2.592 0.034,2.031 -0.864,2.588 -1.254,2.493 -1.115,1.6 -2.254,0.841 -1.539,0.189 -1.564,-0.142 -1.252,-0.207 -1.376,-0.612 -0.678,-0.419 0.36,-0.66 0.768,-0.094 0.512,-0.063 0.256,-0.032 0,0"
              style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path82" />
          </g>
          <g
            id="g84"
            transform="translate(3.6768,8.4219)">
            <path
              d="M 0,0 C -0.562,0.481 0.706,1.419 0.228,1.846 -0.57,1.901 -1.284,2.022 -1.797,2.302 -2.65,0.905 -1.507,-0.559 0,0"
              style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path86" />
          </g>
          <g
            id="g88"
            transform="translate(8.5029,7.4785)">
            <path
              d="M 0,0 C 0.997,-0.071 1.89,-0.224 2.53,-0.571 2.272,0.331 2.471,1.947 2.941,2.758 1.462,2.806 -0.959,2.707 -0.161,0.801 0.159,0.12 -1.125,0.153 -0.96,0.638 -1.042,1.27 -0.412,2.458 -0.965,2.72 -1.398,2.103 -2.543,2.856 -3.016,2.971 -3.42,2.575 -4.274,1.049 -3.299,0.666 -1.884,0.689 -1.262,0.094 0,0"
              style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path90" />
          </g>
          <g
            id="g92"
            transform="translate(34.895,35.9648)">
            <path
              d="m 0,0 c -2.361,-1.226 -3.279,-4.301 -5.176,-6.126 1.987,0.225 2.776,1.984 4.03,3.146 0.23,-1.154 2.218,-0.29 2.275,-0.541 C 0.375,-4.238 -0.4,-4.923 -0.756,-6.149 2.297,-5.244 1.775,-1.474 3.17,0.391 2.191,0.995 1.645,-1.179 0,0 M 11.967,4.25 C 11.947,3.287 10.848,3.708 10.979,2.552 10.846,1.443 12.063,1.391 12.295,0.569 12.646,-6.293 1.953,-4.882 -1.039,-8.456 c -2.092,-2.497 -1.84,-8.011 -2.988,-11.596 1.785,0.813 6.892,1.795 9.765,1.14 1.537,-0.351 3.289,-1.942 4.899,-0.344 -0.241,-2.459 -2.832,-1.439 -4.895,-1.737 -2.652,-0.381 -5.502,-2.574 -8.097,-2.386 -3.769,-3.184 -9.004,-4.486 -15.361,-4.353 0.937,1.274 2.71,1.473 3.71,2.664 -1.513,0.52 -3.147,0.941 -4.774,1.368 1.074,1.491 3.066,1.806 4.509,2.827 -0.925,0.864 -1.492,-0.174 -2.369,-0.23 -3.191,-0.199 -6.018,1.749 -8.747,2.898 2.582,0.647 3.603,3.294 6.653,3.344 0.619,2.369 2.227,3.473 4.154,4.17 -3.367,0.458 -5.355,1.993 -7.947,3.058 1.781,1.279 3.6,2.507 5.629,3.47 -2.698,0.517 -4.598,1.658 -6.123,3.093 5.376,-1.302 9.259,1.153 13.378,3.037 1.93,0.881 6.641,3.144 7.905,2.929 C -0.572,4.697 -0.189,3.052 0.859,2.756 4.311,1.78 8.949,7.28 11.967,4.25"
              style="fill:#86bd9f;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path94" />
          </g>
          <g
            id="g96"
            transform="translate(34.895,35.9648)">
            <path
              d="m 0,0 c -2.361,-1.226 -3.279,-4.301 -5.176,-6.126 1.987,0.225 2.776,1.984 4.03,3.146 0.23,-1.154 2.218,-0.29 2.275,-0.541 C 0.375,-4.238 -0.4,-4.923 -0.756,-6.149 2.297,-5.244 1.775,-1.474 3.17,0.391 2.191,0.995 1.645,-1.179 0,0 Z M 11.967,4.25 C 11.947,3.287 10.848,3.708 10.979,2.552 10.846,1.443 12.063,1.391 12.295,0.569 12.646,-6.293 1.953,-4.882 -1.039,-8.456 c -2.092,-2.497 -1.84,-8.011 -2.988,-11.596 1.785,0.813 6.892,1.795 9.765,1.14 1.537,-0.351 3.289,-1.942 4.899,-0.344 -0.241,-2.459 -2.832,-1.439 -4.895,-1.737 -2.652,-0.381 -5.502,-2.574 -8.097,-2.386 -3.769,-3.184 -9.004,-4.486 -15.361,-4.353 0.937,1.274 2.71,1.473 3.71,2.664 -1.513,0.52 -3.147,0.941 -4.774,1.368 1.074,1.491 3.066,1.806 4.509,2.827 -0.925,0.864 -1.492,-0.174 -2.369,-0.23 -3.191,-0.199 -6.018,1.749 -8.747,2.898 2.582,0.647 3.603,3.294 6.653,3.344 0.619,2.369 2.227,3.473 4.154,4.17 -3.367,0.458 -5.355,1.993 -7.947,3.058 1.781,1.279 3.6,2.507 5.629,3.47 -2.698,0.517 -4.598,1.658 -6.123,3.093 5.376,-1.302 9.259,1.153 13.378,3.037 1.93,0.881 6.641,3.144 7.905,2.929 C -0.572,4.697 -0.189,3.052 0.859,2.756 4.311,1.78 8.949,7.28 11.967,4.25 Z"
              style="fill:none;stroke:#772e16;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
              id="path98" />
          </g>
          <g
            id="g100"
            transform="translate(34.3286,34.9453)">
            <path
              d="m 0,0 c -2.078,-1.146 -2.9,-3.99 -4.574,-5.686 1.742,0.22 2.445,1.848 3.552,2.927 0.195,-1.062 1.942,-0.254 1.991,-0.485 -0.666,-0.667 -1.35,-1.304 -1.668,-2.437 2.681,0.853 2.245,4.33 3.48,6.06 C 1.927,0.931 1.436,-1.08 0,0 M 10.515,3.992 C 10.492,3.103 9.53,3.484 9.639,2.418 9.517,1.394 10.582,1.353 10.781,0.596 c 0.053,-4.447 -9.4,-4.04 -12.228,-7.587 -1.848,-2.318 -2.582,-10.074 -3.61,-13.391 1.563,0.203 7.229,1.979 9.657,1.844 1.125,-0.063 3.917,-0.792 3.127,-0.728 -0.877,0.072 -1.884,0.068 -2.815,-0.08 -2.328,-0.367 -4.84,-2.408 -7.114,-2.248 -3.322,-2.962 -6.98,-3.647 -12.573,-4.303 1.765,0.5 2.328,1.687 2.671,2.312 -1.322,0.473 -2.951,1.022 -4.375,1.406 1.218,0.48 5.063,2.089 5.146,3.005 -0.833,0.25 -3.063,0.807 -3.833,0.75 -2.798,-0.201 -4.811,0.428 -7.197,1.472 2.267,0.612 2.43,2.241 5.103,2.305 0.557,2.19 4.297,4.406 5.906,5.218 -2.718,0.688 -6.031,2.032 -8.296,3 1.568,1.192 4.559,2.756 6.343,3.657 -2.361,0.462 -4.843,0.372 -6.172,1.687 4.706,-1.169 7.414,1.082 11.035,2.844 1.697,0.824 5.841,2.941 6.947,2.749 1.02,-0.177 1.348,-1.693 2.265,-1.961 3.02,-0.879 7.119,4.224 9.747,1.445"
              style="fill:#ffffff;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path102" />
          </g>
          <g
            id="g104"
            transform="translate(36.311,32.6699)">
            <path
              d="M 0,0 C 0.74,0.398 0.275,2.529 -0.58,1.632 0.324,1.643 -0.605,0.224 0,0 m 1.754,3.686 c -1.395,-1.865 -0.873,-5.635 -3.926,-6.54 0.356,1.226 1.131,1.911 1.885,2.628 -0.057,0.251 -2.045,-0.613 -2.276,0.54 -1.253,-1.161 -2.042,-2.92 -4.029,-3.146 1.897,1.826 2.815,4.901 5.176,6.127 1.645,-1.179 2.191,0.995 3.17,0.391"
              style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path106" />
          </g>
          <g
            id="g108"
            transform="translate(35.6079,34.9878)">
            <path
              d="M 0,0 C 0.684,0.718 1.057,-0.988 0.465,-1.307 -0.02,-1.128 0.723,0.008 0,0"
              style="fill:#ffffff;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path110" />
          </g>
          <g
            id="g112"
            transform="translate(46.4692,31.4487)">
            <path
              d="m 0,0 c -0.773,-0.198 -0.953,-1.152 -1.816,-1.235 -0.069,0.193 -0.135,0.389 -0.36,0.462 C -1.434,-0.607 -0.57,1.09 0,0"
              style="fill:#ffffff;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path114" />
          </g>
          <g
            id="g116"
            transform="translate(41.9556,29.6123)">
            <path
              d="m 0,0 c 0.17,-0.928 -0.578,-0.68 -0.766,-1.152 -0.289,0.08 0.004,0.619 -0.334,0.664 0.192,0.387 0.614,0.48 1.1,0.488"
              style="fill:#ffffff;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path118" />
          </g>
          <g
            id="g120"
            transform="translate(43.1665,18.2412)">
            <path
              d="M 0,0 C 0.34,0.356 0.584,0.832 0.791,1.359 1.197,1.641 0.477,-0.346 0.309,-0.872 -0.432,-1.14 -1.213,-0.828 -1.947,-0.594 -1.35,-0.489 -1.416,0.468 -1.309,1.201 -0.967,1.16 -0.627,1.117 -0.285,1.074 -0.377,0.569 -0.283,0.212 0,0"
              style="fill:#ffffff;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path122" />
          </g>
          <g
            id="g124"
            transform="translate(39.3989,18.0781)">
            <path
              d="M 0,0 C -0.713,0.123 -1.32,0.107 -1.691,-0.207 -2.305,0.373 0.23,1.31 0,0"
              style="fill:#ffffff;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path126" />
          </g>
          <g
            id="g128"
            transform="translate(36.0864,17.8174)">
            <path
              d="m 0,0 c -0.344,-0.548 -1.625,0.101 -2.338,0.028 0.16,0.189 0.318,0.382 0.35,0.737 C -1.205,0.605 -0.572,0.328 0,0"
              style="fill:#ffffff;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path130" />
          </g>
          <g
            id="g132"
            transform="translate(11.6719,7.8701)">
            <path
              d="M 0,0 C -0.716,0.651 0.424,1.41 0.284,2.304 0.674,2.398 1.573,1.842 1.598,2.402 2.137,1.977 1.473,0.609 1.539,-0.189 1.026,-0.127 0.513,-0.063 0,0"
              style="fill:#ffffff;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path134" />
          </g>
          <g
            id="g136"
            transform="translate(8.5029,7.4785)">
            <path
              d="M 0,0 C 0.103,0.562 1.1,-0.024 1.568,0.067 1.508,1.192 0.982,0.52 -0.161,0.801 -0.959,2.707 1.462,2.806 2.941,2.758 2.471,1.947 2.272,0.331 2.53,-0.571 1.89,-0.224 0.997,-0.071 0,0"
              style="fill:#ffffff;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path138" />
          </g>
          <g
            id="g140"
            transform="translate(1.8794,10.7236)">
            <path
              d="M 0,0 C 0.513,-0.279 1.228,-0.4 2.025,-0.456 2.503,-0.883 1.236,-1.82 1.797,-2.302 0.291,-2.86 -0.853,-1.396 0,0"
              style="fill:#ffffff;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path142" />
          </g>
          <g
            id="g144"
            transform="translate(4.4727,8.1152)">
            <path
              d="M 0,0 C -0.78,0.307 -0.097,1.527 0.227,1.846 0.605,1.753 1.521,1.149 1.868,1.645 2.311,1.434 1.806,0.483 1.872,-0.022 0.646,0.798 1.052,-0.398 0.306,0.796 0.101,0.821 0.042,0.659 -0.129,0.641 -0.072,0.163 0.221,0.849 0.461,0.36 0.425,0.088 0.078,0.217 0,0"
              style="fill:#ffffff;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path146" />
          </g>
          <g
            id="g148"
            transform="translate(5.2036,8.1445)">
            <path
              d="M 0,0 C 0.098,0.271 0.532,0.11 0.576,0.451 0.276,1.062 -0.089,0.204 -0.162,0.8 0.052,0.823 0.126,1.025 0.382,0.993 1.315,-0.497 0.809,0.995 2.339,-0.028 2.175,-0.513 3.458,-0.546 3.139,0.135 4.282,-0.146 4.807,0.526 4.868,-0.599 4.399,-0.69 3.402,-0.104 3.299,-0.666 2.037,-0.572 1.415,0.023 0,0"
              style="fill:#fefefe;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path150" />
          </g>
          <g
            id="g152"
            transform="translate(41.0396,17.877)">
            <path
              d="m 0,0 c -0.219,0.203 -0.518,0.339 -1,0.332 0.24,0.641 0.654,1.061 1.201,1.31 C 0.697,1.295 0.094,0.38 0,0"
              style="fill:#ffffff;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path154" />
          </g>
          <g
            id="g156"
            transform="translate(13.2104,7.6807)">
            <path
              d="M 0,0 C 0.256,-0.032 0.512,-0.063 0.768,-0.094 0.36,-0.66 -0.678,-0.419 -1.376,-0.612 -1.252,-0.207 -1.564,-0.142 -1.539,0.189 -1.025,0.127 -0.513,0.063 0,0"
              style="fill:#fefefe;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path158" />
          </g>
          <g
            id="g160"
            transform="translate(46.4663,23.3213)">
            <path
              d="m 0,0 c 1.714,-0.142 3.945,1.004 4.519,2.722 0.103,0.31 -0.318,0.23 -0.395,0 C 3.626,1.228 1.597,0.323 0.143,0.443 -0.076,0.462 -0.281,0.022 0,0"
              style="fill:#86bd9f;fill-opacity:1;fill-rule:nonzero;stroke:none"
              id="path162" />
          </g>
          <g
            id="g164"
            transform="translate(47.7095,20.4111)">
            <path
              d="M 0,0 C 0.553,-0.095 1.104,-0.166 1.66,-0.06 2.1,0.025 2.478,0.297 2.831,0.556 3.055,0.72 2.923,1.068 2.657,0.874 1.879,0.305 1.181,0.269 0.238,0.43 0.019,0.467 -0.24,0.041 0,0"
              style="fill:#86bd9f;fill-opacity:1;fill-rule:nonzero;stroke:none"
              id="path166" />
          </g>
          <g
            id="g168"
            transform="translate(48.8052,26.8613)">
            <path
              d="M 0,0 C 0.574,0.119 1.13,0.27 1.621,0.601 1.979,0.843 2.224,1.224 2.45,1.583 2.627,1.863 2.252,1.928 2.106,1.698 1.595,0.89 0.966,0.622 0.037,0.43 -0.184,0.384 -0.303,-0.063 0,0"
              style="fill:#86bd9f;fill-opacity:1;fill-rule:nonzero;stroke:none"
              id="path170" />
          </g>
          <g
            id="g172"
            transform="translate(49.0425,29.0322)">
            <path
              d="M 0,0 C 2.77,1.838 3.496,4.382 3.886,7.584 3.941,8.041 3.301,7.747 3.261,7.416 2.9,4.458 2.295,2.173 -0.26,0.479 -0.608,0.247 -0.407,-0.271 0,0"
              style="fill:#86bd9f;fill-opacity:1;fill-rule:nonzero;stroke:none"
              id="path174" />
          </g>
        </g>
      </g>
    </g>
    <g v-else
     id="g510"
     transform="matrix(1.3333333,0,0,-1.3333333,0,73.2532)">
      <g
        id="g512">
        <g
          id="g514"
          clip-path="url(#clipPath518)">
          <g
            id="g520"
            transform="translate(53.4399,1.8496)">
            <path
              d="m 0,0 c 0,-0.419 -0.281,-0.759 -0.633,-0.759 h -51.174 c -0.351,0 -0.633,0.34 -0.633,0.759 v 50.926 c 0,0.42 0.282,0.757 0.633,0.757 H -0.633 C -0.281,51.683 0,51.346 0,50.926 Z"
              style="fill:none;fill-opacity:1;fill-rule:nonzero;stroke:none"
              id="path522" />
          </g>
          <g
            id="g524"
            transform="translate(53.4399,1.8496)">
            <path
              d="m 0,0 c 0,-0.419 -0.281,-0.759 -0.633,-0.759 h -51.174 c -0.351,0 -0.633,0.34 -0.633,0.759 v 50.926 c 0,0.42 0.282,0.757 0.633,0.757 H -0.633 C -0.281,51.683 0,51.346 0,50.926 Z"
              style="fill:none;stroke:#772e18;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
              id="path526" />
          </g>
          <g
            id="g528"
            transform="translate(1.583,35.1284)">
            <path
              d="m 0,0 c 3.903,-2.875 8.832,-4.313 14.558,-3.619 -2.687,0.911 -4.329,2.64 -6.252,4.15 2.215,0.97 3.042,-0.431 4.611,-0.567 4.502,-0.391 10.11,2.904 14.368,4.735 3.468,1.492 5.281,2.657 7.463,-0.657 3.468,0.385 7.968,4.492 11.332,1.208 0.039,-1.137 -0.635,-1.363 -1.247,-1.668 1.758,-1.522 1.629,-6.599 0.467,-8.902 -0.802,-0.163 -0.384,0.626 -0.386,1.088 -1.641,-1.492 -2.993,-1.519 -4.766,-2.794 -1.141,-0.042 -1.049,0.879 -1.955,1.021 -0.586,-0.436 -0.541,-1.681 -1.053,-2.213 -1.117,-0.102 0.19,1.694 -0.836,1.665 -4.076,-0.118 -4.888,-4.417 -5.748,-8.658 1.934,0.889 4.768,3.191 5.721,6.321 1.576,0.451 2.59,1.625 5.058,0.936 1.581,0.25 1.93,2.077 4.319,1.292 0.734,-7.372 -9.164,-3.681 -10.514,-9.372 -0.894,5.803 10.303,2.807 9.94,8.921 -1.579,0.242 -1.895,-1.133 -3.039,-1.447 -4.551,0.983 -6.209,-1.737 -7.385,-5.074 -1.953,-0.764 -3.823,-1.632 -4.412,-4.139 0.759,-0.566 2.082,0.687 2.078,2.084 0.834,-0.428 1.773,-0.777 2.435,-1.34 0.618,0.875 2.467,1.473 3.713,0.585 0.301,0.698 -0.279,0.708 -0.097,1.314 2.029,0.068 4.734,-0.727 5.57,0.875 1.183,-0.518 -0.176,-2.412 -0.156,-3.363 0.158,-0.648 0.828,0.487 1.57,0.068 -0.311,-1.284 -1.166,-1.867 -1.66,-2.917 -4.787,0.002 -8.035,-1.968 -12.291,-2.651 -7.871,-5.365 -19.939,-6.674 -31.468,-4.193"
              style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path530" />
          </g>
          <g
            id="g532"
            transform="translate(35.7544,38.7207)">
            <path
              d="m 0,0 c -1.049,0.296 -1.432,1.941 -2.598,2.14 -1.263,0.215 -5.975,-2.048 -7.904,-2.929 -4.119,-1.883 -8.002,-4.338 -13.378,-3.037 1.525,-1.435 3.425,-2.576 6.123,-3.093 -2.03,-0.963 -3.848,-2.19 -5.63,-3.47 2.593,-1.065 4.58,-2.6 7.948,-3.058 -1.927,-0.697 -3.536,-1.801 -4.155,-4.17 -3.049,-0.05 -4.071,-2.696 -6.652,-3.344 2.729,-1.148 5.556,-3.097 8.746,-2.897 0.878,0.055 1.444,1.093 2.37,0.229 -1.443,-1.02 -3.435,-1.336 -4.51,-2.827 1.627,-0.427 3.262,-0.848 4.775,-1.368 -1.001,-1.191 -2.774,-1.39 -3.711,-2.664 6.358,-0.133 11.593,1.17 15.361,4.353 2.596,-0.188 5.445,2.005 8.098,2.386 2.062,0.298 4.654,-0.722 4.894,1.737 -1.609,-1.598 -3.361,-0.007 -4.898,0.344 -2.873,0.655 -7.981,-0.327 -9.766,-1.14 1.149,3.585 0.897,9.099 2.989,11.597 2.992,3.573 13.685,2.162 13.334,9.024 -0.233,0.822 -1.45,0.874 -1.317,1.983 -0.131,1.156 0.969,0.735 0.988,1.699 C 8.09,4.524 3.451,-0.976 0,0"
              style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path534" />
          </g>
          <g
            id="g536"
            transform="translate(42.4165,29.7939)">
            <path
              d="M 0,0 C 0.225,-0.072 0.291,-0.267 0.359,-0.462 1.223,-0.378 1.402,0.575 2.176,0.773 1.604,1.865 0.744,0.167 0,0"
              style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path538" />
          </g>
          <g
            id="g540"
            transform="translate(41.0845,29.124)">
            <path
              d="M 0,0 C 0.338,-0.044 0.045,-0.583 0.336,-0.664 0.521,-0.192 1.27,-0.439 1.102,0.488 0.615,0.48 0.191,0.388 0,0"
              style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path542" />
          </g>
          <g
            id="g544"
            transform="translate(35.3364,17.0176)">
            <path
              d="m 0,0 c -0.342,0.044 -0.684,0.086 -1.025,0.126 -0.106,-0.734 -0.039,-1.689 -0.639,-1.795 0.738,-0.234 1.518,-0.545 2.256,-0.276 0.17,0.524 0.89,2.511 0.482,2.23 C 0.869,-0.243 0.625,-0.72 0.283,-1.074 0.002,-0.862 -0.094,-0.504 0,0"
              style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path546" />
          </g>
          <g
            id="g548"
            transform="translate(33.6958,17.2197)">
            <path
              d="m 0,0 c -0.547,-0.25 -0.961,-0.668 -1.201,-1.31 0.482,0.007 0.783,-0.128 1,-0.331 C -0.109,-1.262 0.494,-0.346 0,0"
              style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path550" />
          </g>
          <g
            id="g552"
            transform="translate(30.1626,15.5723)">
            <path
              d="M 0,0 C 0.371,0.316 0.977,0.331 1.689,0.209 1.922,1.518 -0.615,0.581 0,0"
              style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path554" />
          </g>
          <g
            id="g556"
            transform="translate(34.2896,18.3525)">
            <path
              d="M 0,0 C -0.031,-0.355 -0.191,-0.548 -0.35,-0.736 0.365,-0.664 1.643,-1.312 1.988,-0.764 1.416,-0.439 0.785,-0.16 0,0"
              style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path558" />
          </g>
          <g
            id="g560"
            transform="translate(13.2104,7.6807)">
            <path
              d="M 0,0 C -0.065,0.799 0.598,2.166 0.059,2.592 0.034,2.031 -0.864,2.588 -1.254,2.493 -1.115,1.6 -2.254,0.841 -1.539,0.189 -1.564,-0.142 -1.252,-0.207 -1.376,-0.612 -0.678,-0.419 0.36,-0.66 0.768,-0.094 0.512,-0.063 0.256,-0.032 0,0"
              style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path562" />
          </g>
          <g
            id="g564"
            transform="translate(3.6768,8.4219)">
            <path
              d="M 0,0 C -0.562,0.481 0.706,1.419 0.228,1.846 -0.57,1.901 -1.284,2.022 -1.797,2.302 -2.65,0.905 -1.507,-0.559 0,0"
              style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path566" />
          </g>
          <g
            id="g568"
            transform="translate(8.5029,7.4785)">
            <path
              d="M 0,0 C 0.997,-0.071 1.89,-0.224 2.53,-0.571 2.272,0.331 2.471,1.947 2.941,2.758 1.462,2.806 -0.959,2.707 -0.161,0.801 0.159,0.12 -1.125,0.153 -0.96,0.638 -1.042,1.27 -0.412,2.458 -0.965,2.72 -1.398,2.103 -2.543,2.856 -3.016,2.971 -3.42,2.575 -4.274,1.049 -3.299,0.666 -1.884,0.689 -1.262,0.094 0,0"
              style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path570" />
          </g>
          <g
            id="g572"
            transform="translate(34.895,35.9648)">
            <path
              d="m 0,0 c -2.361,-1.226 -3.279,-4.301 -5.176,-6.126 1.987,0.225 2.776,1.984 4.03,3.146 0.23,-1.154 2.218,-0.29 2.275,-0.541 C 0.375,-4.238 -0.4,-4.923 -0.756,-6.149 2.297,-5.244 1.775,-1.474 3.17,0.391 2.191,0.995 1.645,-1.179 0,0 M 11.967,4.25 C 11.947,3.287 10.848,3.708 10.979,2.552 10.846,1.443 12.063,1.391 12.295,0.569 12.646,-6.293 1.953,-4.882 -1.039,-8.456 c -2.092,-2.497 -1.84,-8.011 -2.988,-11.596 1.785,0.813 6.892,1.795 9.765,1.14 1.537,-0.351 3.289,-1.942 4.899,-0.344 -0.241,-2.459 -2.832,-1.439 -4.895,-1.737 -2.652,-0.381 -5.502,-2.574 -8.097,-2.386 -3.769,-3.184 -9.004,-4.486 -15.361,-4.353 0.937,1.274 2.71,1.473 3.71,2.664 -1.513,0.52 -3.147,0.941 -4.774,1.368 1.074,1.491 3.066,1.806 4.509,2.827 -0.925,0.864 -1.492,-0.174 -2.369,-0.23 -3.191,-0.199 -6.018,1.749 -8.747,2.898 2.582,0.647 3.603,3.294 6.653,3.344 0.619,2.369 2.227,3.473 4.154,4.17 -3.367,0.458 -5.355,1.993 -7.947,3.058 1.781,1.279 3.6,2.507 5.629,3.47 -2.698,0.517 -4.598,1.658 -6.123,3.093 5.376,-1.302 9.259,1.153 13.378,3.037 1.93,0.881 6.641,3.144 7.905,2.929 C -0.572,4.697 -0.189,3.052 0.859,2.756 4.311,1.78 8.949,7.28 11.967,4.25"
              style="fill:#86bd9f;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path574" />
          </g>
          <g
            id="g576"
            transform="translate(34.895,35.9648)">
            <path
              d="m 0,0 c -2.361,-1.226 -3.279,-4.301 -5.176,-6.126 1.987,0.225 2.776,1.984 4.03,3.146 0.23,-1.154 2.218,-0.29 2.275,-0.541 C 0.375,-4.238 -0.4,-4.923 -0.756,-6.149 2.297,-5.244 1.775,-1.474 3.17,0.391 2.191,0.995 1.645,-1.179 0,0 Z M 11.967,4.25 C 11.947,3.287 10.848,3.708 10.979,2.552 10.846,1.443 12.063,1.391 12.295,0.569 12.646,-6.293 1.953,-4.882 -1.039,-8.456 c -2.092,-2.497 -1.84,-8.011 -2.988,-11.596 1.785,0.813 6.892,1.795 9.765,1.14 1.537,-0.351 3.289,-1.942 4.899,-0.344 -0.241,-2.459 -2.832,-1.439 -4.895,-1.737 -2.652,-0.381 -5.502,-2.574 -8.097,-2.386 -3.769,-3.184 -9.004,-4.486 -15.361,-4.353 0.937,1.274 2.71,1.473 3.71,2.664 -1.513,0.52 -3.147,0.941 -4.774,1.368 1.074,1.491 3.066,1.806 4.509,2.827 -0.925,0.864 -1.492,-0.174 -2.369,-0.23 -3.191,-0.199 -6.018,1.749 -8.747,2.898 2.582,0.647 3.603,3.294 6.653,3.344 0.619,2.369 2.227,3.473 4.154,4.17 -3.367,0.458 -5.355,1.993 -7.947,3.058 1.781,1.279 3.6,2.507 5.629,3.47 -2.698,0.517 -4.598,1.658 -6.123,3.093 5.376,-1.302 9.259,1.153 13.378,3.037 1.93,0.881 6.641,3.144 7.905,2.929 C -0.572,4.697 -0.189,3.052 0.859,2.756 4.311,1.78 8.949,7.28 11.967,4.25 Z"
              style="fill:none;stroke:#772e16;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
              id="path578" />
          </g>
          <g
            id="g580"
            transform="translate(36.311,32.6699)">
            <path
              d="M 0,0 C 0.74,0.398 0.275,2.529 -0.58,1.632 0.324,1.643 -0.605,0.224 0,0 m 1.754,3.686 c -1.395,-1.865 -0.873,-5.635 -3.926,-6.54 0.356,1.226 1.131,1.911 1.885,2.628 -0.057,0.251 -2.045,-0.613 -2.276,0.54 -1.253,-1.161 -2.042,-2.92 -4.029,-3.146 1.897,1.826 2.815,4.901 5.176,6.127 1.645,-1.179 2.191,0.995 3.17,0.391"
              style="fill:#000000;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path582" />
          </g>
          <g
            id="g584"
            transform="translate(35.6079,34.9878)">
            <path
              d="M 0,0 C 0.684,0.718 1.057,-0.988 0.465,-1.307 -0.02,-1.128 0.723,0.008 0,0"
              style="fill:#ffffff;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path586" />
          </g>
          <g
            id="g588"
            transform="translate(46.4692,31.4487)">
            <path
              d="m 0,0 c -0.773,-0.198 -0.953,-1.152 -1.816,-1.235 -0.069,0.193 -0.135,0.389 -0.36,0.462 C -1.434,-0.607 -0.57,1.09 0,0"
              style="fill:#ffffff;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path590" />
          </g>
          <g
            id="g592"
            transform="translate(41.9556,29.6123)">
            <path
              d="m 0,0 c 0.17,-0.928 -0.578,-0.68 -0.766,-1.152 -0.289,0.08 0.004,0.619 -0.334,0.664 0.192,0.387 0.614,0.48 1.1,0.488"
              style="fill:#ffffff;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path594" />
          </g>
          <g
            id="g596"
            transform="translate(43.1665,18.2412)">
            <path
              d="M 0,0 C 0.34,0.356 0.584,0.832 0.791,1.359 1.197,1.641 0.477,-0.346 0.309,-0.872 -0.432,-1.14 -1.213,-0.828 -1.947,-0.594 -1.35,-0.489 -1.416,0.468 -1.309,1.201 -0.967,1.16 -0.627,1.117 -0.285,1.074 -0.377,0.569 -0.283,0.212 0,0"
              style="fill:#ffffff;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path598" />
          </g>
          <g
            id="g600"
            transform="translate(39.3989,18.0781)">
            <path
              d="M 0,0 C -0.713,0.123 -1.32,0.107 -1.691,-0.207 -2.305,0.373 0.23,1.31 0,0"
              style="fill:#ffffff;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path602" />
          </g>
          <g
            id="g604"
            transform="translate(36.0864,17.8174)">
            <path
              d="m 0,0 c -0.344,-0.548 -1.625,0.101 -2.338,0.028 0.16,0.189 0.318,0.382 0.35,0.737 C -1.205,0.605 -0.572,0.328 0,0"
              style="fill:#ffffff;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path606" />
          </g>
          <g
            id="g608"
            transform="translate(11.6719,7.8701)">
            <path
              d="M 0,0 C -0.716,0.651 0.424,1.41 0.284,2.304 0.674,2.398 1.573,1.842 1.598,2.402 2.137,1.977 1.473,0.609 1.539,-0.189 1.026,-0.127 0.513,-0.063 0,0"
              style="fill:#ffffff;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path610" />
          </g>
          <g
            id="g612"
            transform="translate(8.5029,7.4785)">
            <path
              d="M 0,0 C 0.103,0.562 1.1,-0.024 1.568,0.067 1.508,1.192 0.982,0.52 -0.161,0.801 -0.959,2.707 1.462,2.806 2.941,2.758 2.471,1.947 2.272,0.331 2.53,-0.571 1.89,-0.224 0.997,-0.071 0,0"
              style="fill:#ffffff;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path614" />
          </g>
          <g
            id="g616"
            transform="translate(1.8794,10.7236)">
            <path
              d="M 0,0 C 0.513,-0.279 1.228,-0.4 2.025,-0.456 2.503,-0.883 1.236,-1.82 1.797,-2.302 0.291,-2.86 -0.853,-1.396 0,0"
              style="fill:#ffffff;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path618" />
          </g>
          <g
            id="g620"
            transform="translate(4.4727,8.1152)">
            <path
              d="M 0,0 C -0.78,0.307 -0.097,1.527 0.227,1.846 0.605,1.753 1.521,1.149 1.868,1.645 2.311,1.434 1.806,0.483 1.872,-0.022 0.646,0.798 1.052,-0.398 0.306,0.796 0.101,0.821 0.042,0.659 -0.129,0.641 -0.072,0.163 0.221,0.849 0.461,0.36 0.425,0.088 0.078,0.217 0,0"
              style="fill:#ffffff;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path622" />
          </g>
          <g
            id="g624"
            transform="translate(5.2036,8.1445)">
            <path
              d="M 0,0 C 0.098,0.271 0.532,0.11 0.576,0.451 0.276,1.062 -0.089,0.204 -0.162,0.8 0.052,0.823 0.126,1.025 0.382,0.993 1.315,-0.497 0.809,0.995 2.339,-0.028 2.175,-0.513 3.458,-0.546 3.139,0.135 4.282,-0.146 4.807,0.526 4.868,-0.599 4.399,-0.69 3.402,-0.104 3.299,-0.666 2.037,-0.572 1.415,0.023 0,0"
              style="fill:#fefefe;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path626" />
          </g>
          <g
            id="g628"
            transform="translate(41.0396,17.877)">
            <path
              d="m 0,0 c -0.219,0.203 -0.518,0.339 -1,0.332 0.24,0.641 0.654,1.061 1.201,1.31 C 0.697,1.295 0.094,0.38 0,0"
              style="fill:#ffffff;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path630" />
          </g>
          <g
            id="g632"
            transform="translate(13.2104,7.6807)">
            <path
              d="M 0,0 C 0.256,-0.032 0.512,-0.063 0.768,-0.094 0.36,-0.66 -0.678,-0.419 -1.376,-0.612 -1.252,-0.207 -1.564,-0.142 -1.539,0.189 -1.025,0.127 -0.513,0.063 0,0"
              style="fill:#fefefe;fill-opacity:1;fill-rule:evenodd;stroke:none"
              id="path634" />
          </g>
        </g>
      </g>
    </g>
    <title
      :id="iconName"
      lang="en"
    >Discussion Forum</title>
  </svg>
</template>

<script>
export default {
  props: {
    iconName: {
      type: String,
      default: 'box'
    },
    width: {
      type: [Number, String],
      default: 56
    },
    height: {
      type: [Number, String],
      default: 56
    },
    iconColor: {
      type: String,
      default: '#84bd9f'
    }
  },
  data () {
    return {
      isHover:false,
    }
  }
}
</script>